// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.cmsContainer[data-v-b95720c0]
	{
		box-sizing: border-box;
		overflow-x: clip;
		overflow-y: auto;
		width: calc(100vw - 100px);
}
`, "",{"version":3,"sources":["webpack://./www/vues/client/ClientCMSContainer.vue"],"names":[],"mappings":";AAkCC;;EAEC,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC3B","sourcesContent":["<template>\r\n\t<div class=\"cmsContainer\">\r\n\t\t<router-view></router-view>\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\r\n\texport default {\r\n\t\tcomponents: { },\r\n\t\tprops:\r\n\t\t{\r\n\t\t},\r\n\t\tdata()\r\n\t\t{\r\n\t\t\treturn {\r\n\t\t\t};\r\n\t\t},\r\n\t\tcreated()\r\n\t\t{\r\n\t\t},\r\n\t\tcomputed:\r\n\t\t{\r\n\t\t},\r\n\t\tmethods:\r\n\t\t{\r\n\t\t},\r\n\t\twatch:\r\n\t\t{\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style scoped>\r\n\t.cmsContainer\r\n\t{\r\n\t\tbox-sizing: border-box;\r\n\t\toverflow-x: clip;\r\n\t\toverflow-y: auto;\r\n\t\twidth: calc(100vw - 100px);\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
